import React from 'react';
import cn from 'clsx';
import { string, node, bool, func } from 'prop-types';
import ModalContext from '../../context/ModalContext.js';
import Backdrop from '../../atoms/Backdrop/index.jsx';
import Body from './body.jsx';
import Header from './header.jsx';
import Footer from './footer.jsx';
import SubFooter from './subFooter.jsx';

/**
 * Modal component.
 */
const Modal = ({
  className,
  children,
  show,
  onClose,
  fluid,
  hideBackground
}) => /*#__PURE__*/React.createElement(ModalContext.Provider, {
  value: {
    show,
    onClose,
    fluid
  }
}, /*#__PURE__*/React.createElement("div", {
  style: {
    display: show ? null : 'none'
  },
  className: cn('modal', className, fluid && 'modal--fluid')
}, children), /*#__PURE__*/React.createElement(Backdrop, {
  active: show,
  className: "modal__backdrop",
  onClick: () => onClose(),
  hideBackground: hideBackground
}));
Modal.defaultProps = {
  children: null,
  className: null,
  show: false,
  onClose: null,
  fluid: false,
  hideBackground: false
};
Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The modal body */
  children: node,
  /** Additional class names to add to the component root. */
  className: string,
  /** Show the modal. */
  show: bool,
  /** A function to call to close the modal. */
  onClose: func,
  /** Do not set a fixed height for the modal. */
  fluid: bool,
  /** Hide background by solid white overlay */
  hideBackground: bool
} : {};
Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;
Modal.SubFooter = SubFooter;
export default Modal;